import { render, staticRenderFns } from "./Tombola.vue?vue&type=template&id=266c43fe"
import script from "./Tombola.vue?vue&type=script&lang=js"
export * from "./Tombola.vue?vue&type=script&lang=js"
import style0 from "./Tombola.vue?vue&type=style&index=0&id=266c43fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports